import dayjs from 'dayjs'
import { TimeRangePickerProps } from 'antd'

export const DATE_RANGE_PRESET: TimeRangePickerProps['presets'] = [
  { label: 'Today', value: [dayjs(), dayjs()] },
  { label: 'Yesterday', value: [dayjs().add(-1, 'd'), dayjs().add(-1, 'd')] },
  { label: 'Last 7 Days', value: [dayjs().add(-6, 'd'), dayjs()] },
  { label: 'Last 14 Days', value: [dayjs().add(-13, 'd'), dayjs()] },
  { label: 'Last 30 Days', value: [dayjs().add(-29, 'd'), dayjs()] },
  { label: 'This Month', value: [dayjs().startOf('month'), dayjs()] },
  { label: 'Last Month', value: [dayjs().add(-1, 'month').startOf('month'), dayjs().add(-1, 'month').endOf('month')] },
  { label: 'Last 90 Days', value: [dayjs().add(-89, 'd'), dayjs()] },
  { label: 'This Year', value: [dayjs().startOf('year'), dayjs()] },
]
